import { render } from "./SliderCategories.vue?vue&type=template&id=acb1e95a"
import script from "./SliderCategories.vue?vue&type=script&lang=js"
export * from "./SliderCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__